import React from 'react';
import { KPIGrid, KPI, KpiLabel, KpiValue } from '../ShelfPage/styles';

interface ConsumptionHeaderProps {
  totalCrawls?: number | string;
  creditsUsed?: number | string | null;
  successRate?: number | string | null;
  activeCrawls?: number | string;
}

const ConsumptionHeader: React.FC<ConsumptionHeaderProps> = ({ totalCrawls, creditsUsed, successRate, activeCrawls }) => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '16px 0px 0px 0px' }}>
        <div style={{ fontWeight: 600, fontSize: '20px' }}>Consumption</div>
      </div>
      <KPIGrid>
        <KPI>
          <KpiLabel>Total Agents</KpiLabel>
          <KpiValue>{typeof totalCrawls === 'number' ? totalCrawls : (totalCrawls ?? '—')}</KpiValue>
        </KPI>
        <KPI>
          <KpiLabel>Credits Used</KpiLabel>
          <KpiValue>{typeof creditsUsed === 'number' ? creditsUsed.toLocaleString() : (creditsUsed ?? '—')}</KpiValue>
        </KPI>
        <KPI>
          <KpiLabel>Success Rate</KpiLabel>
          <KpiValue>{successRate ?? '—'}</KpiValue>
        </KPI>
        <KPI>
          <KpiLabel>Active Agents</KpiLabel>
          <KpiValue>{typeof activeCrawls === 'number' ? activeCrawls : (activeCrawls ?? '—')}</KpiValue>
        </KPI>
      </KPIGrid>
    </div>
  );
};

export default ConsumptionHeader;


